import { optimisticDispatch } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setName
} from '../redux/blockers'

type Payload = {
  blockerId: number
  boardId?: number
  name: string
}

const requestChangeBlockerName = ({
  blockerId,
  boardId,
  name,
}: Payload) => async dispatch => {
  const optimisticAction = optimisticDispatch(dispatch, setName({
    blockerId,
    name,
  }))

  try {
    await apiAction('RenameBlocker', {
      id: blockerId,
      boardId,
      name,
    })
  } catch (error) {
    if (
      error.code !== 303 // NoChange
    ) {
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}

export default requestChangeBlockerName
